import TransactionsProvider from './TransactionsProvider'
import TransactionsTable from './TransactionsTable'
import TransactionsDateRangePicker from './TransactionsDateRangePicker'
import TransactionsFilter from './TransactionsFilter'
import TransactionsTextSearch from './TransactionsTextSearch'
import TransactionsTableFilters from './TransactionsTableFilters'
import TransactionsTableActions from './TransactionsTableActions'
import TransactionsPopUp from './TransactionsPopUp'
import TransactionDates from './TransactionDates'
import CustomRangeDialog from './CustomRangeDialog'

const transactionsModule = {
  DDPCustomRangeDialog: CustomRangeDialog,
  DDPTransactionDates: TransactionDates,
  DDPTransactionsProvider: TransactionsProvider,
  DDPTransactionsDateRangePicker: TransactionsDateRangePicker,
  DDPTransactionsFilter: TransactionsFilter,
  DDPTransactionsTable: TransactionsTable,
  DDPTransactionsTableActions: TransactionsTableActions,
  DDPTransactionsTableFilters: TransactionsTableFilters,
  DDPTransactionsTextSearch: TransactionsTextSearch,
  DDPTransactionsPopUp: TransactionsPopUp
}

export default transactionsModule
